import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>Find Balance</h3>
          <p>Tu dinero, tus reglas, tu futuro.</p>
        </div>
        <div className="footer-column">
          <h4>Navegación</h4>
          <ul>
            <li><a href="#features" data-event="footer_features">Características</a></li>
            <li><a href="#about" data-event="footer_about">Sobre Nosotros</a></li>
            <li><a href="#contact" data-event="footer_contact">Contacto</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Legal y Social</h4>
          <ul>
            <li><a href="https://app.findbalance.es/terms" data-event="footer_terms">Términos de Servicio</a></li>
            <li><a href="https://app.findbalance.es/privacy" data-event="footer_privacy">Política de Privacidad</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Find Balance. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;